export function canResumeEncounter(status) {
  return ["in_consultation", "in_progress", "open", "active", "completed", "closed", "clinical_complete", "visit_complete"].includes(String(status || "").trim().toLowerCase().replace(/\s+/g, "_"));
}
